import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";

const EveryDayFoamCutting = () => {
  const [returns, setReturns] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);


  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const fetchReturns = async () => {
    try {
      const response = await axiosInstance.get("/api/get-EveryDayFoamCutting");
      setReturns(response.data);
    } catch (error) {
      console.error("Error fetching RM returns:", error);
    }
  };

  useEffect(() => {
    fetchReturns();
  }, []);





  

  const columns = [
   {
      name: "Date",
      selector: (row) => new Date(row.CalendarDate).toLocaleString("en-GB"),
      sortable: true
    }, { name: "Target", selector: (row) => row.Target, sortable: true },
    { name: "TotalQuantity", selector: (row) => row.TotalQuantity, sortable: true },
    { name: "PercAchieved", selector: (row) => row.PercAchieved, sortable: true },
    
    // { name: "Remarks", selector: (row) =>(
    //   <span
    //   data-bs-toggle="tooltip"
    //   data-bs-placement="top"
    //   title={row.Remarks}
    //   >
    //   {row.Remarks || "N/A"}
    //   </span>
    // ), sortable: true },

   

    
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{height:"-webkit-fill-available"}}>
          <div className="mb-3">
          <h3> <p className="text-center">Daily Foam Cutting</p></h3>
          </div>
          <DataTable columns={columns} data={returns} pagination />
        </main>
      </div>

  
    </div>
  );
};

export default EveryDayFoamCutting;
